import { DATA_NAMES, CARD_FIELD_NAMES } from './constants'

export const getFieldName = value => {
  if (CARD_FIELD_NAMES[value]) {
    return `${DATA_NAMES.creditCard}.${value}`
  }
  return `${DATA_NAMES.billingAddress}.${value}`
}
